import script from "./AppContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContainer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__